import React, { useState, useEffect } from "react";
import { Modal, Input, Select } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const DocProductModal = ({ visible, onClose, onSubmit, productList = [] }) => {
  const [version, setVersion] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { t } = useTranslation();
  useEffect(() => {
    if (visible) {
      setVersion("");
      setSelectedProduct(null);
    }
  }, [visible]);

  const handleOk = () => {
    if (!version || !selectedProduct) {
      alert(t("Lütfen versiyon girin ve ürün seçin."));
      return;
    }

    const selected = productList.find((p) => p.code === selectedProduct);
    if (!selected) {
      alert(t("Ürün bulunamadı."));
      return;
    }

    onSubmit?.({
      version,
      product: selected.code,
      productName: selected.name,
      docGroups: selected.docGroups || [],
    });

    onClose();
  };

  return (
    <Modal
      open={visible}
     title={t("Versiyon ve Ürün Seçimi")}
      onCancel={onClose}
      onOk={handleOk}
      okText={t("Kaydet")}
      cancelText={t("İptal")}
      okButtonProps={{
        style: {
          backgroundColor: "#1890ff",
          borderColor: "#1890ff",
          color: "white",
        },
      }}
      cancelButtonProps={{
        style: {
          color: "#ff4d4f",
          borderColor: "#ff4d4f",
        },
      }}
    >
      <div className="flex flex-col gap-4">
        <div>
       <label className="text-sm text-gray-700">{t("Ürün seçin")}</label>
          <Select
            value={selectedProduct}
            onChange={setSelectedProduct}
            className="w-full"
            showSearch
            optionFilterProp="children"
          >
            {productList.map((product) => (
              <Option key={product.code} value={product.code}>
                {product.name}
              </Option>
            ))}
          </Select>
        </div>
        <div>
        <label className="text-sm text-gray-700">{t("Ürün Versiyon girin")}</label>
          <Input
            value={version}
            onChange={(e) => setVersion(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DocProductModal;
